// Loading component - Centered loading spinner
import { Center, Loader, Stack, Text } from '@mantine/core';

interface LoadingProps {
  message?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const Loading = ({ message = 'Loading...', size = 'md' }: LoadingProps) => {
  return (
    <Center style={{ minHeight: '100vh' }}>
      <Stack align="center" gap="md">
        <Loader size={size} />
        <Text c="dimmed">{message}</Text>
      </Stack>
    </Center>
  );
};
